import React from 'react';
import './WindshieldProtectionPage.css';
import { FaShieldAlt, FaEye, FaTemperatureHigh, FaCar, FaTools, FaCheckCircle } from 'react-icons/fa';

const WindshieldProtectionPage = () => {
  return (
    <div className="windshield-protection-main">
      <section className="windshield-protection-hero">
        <div className="windshield-protection-hero-content">
          <h1>Windshield Protection Film</h1>
        </div>
      </section>

      <section className="windshield-protection-main-content">
        <h2>Cleargard — Advanced Windshield Protection Film</h2>
        <p>Cleargard is our next-generation windshield protection film, designed to safeguard your vehicle's most vulnerable glass surface against harsh environmental conditions and everyday impacts. Whether you're cruising at high speeds, navigating through sandstorms, or simply parked under unpredictable weather, Cleargard helps preserve your windshield's factory-fresh clarity — reducing the risk of costly repairs or replacements.</p>
        
        <div className="windshield-image-container">
          <img 
            src="https://i.postimg.cc/63KMbmxv/windshield-protec-derma-1.png" 
            alt="DermaProtec Cleargard Windshield Protection Technology" 
            className="windshield-content-image"
          />
        </div>
        <hr />
        <h3>Proven Protection Without Compromise</h3>
        <p>Cleargard has been rigorously tested to meet some of the toughest international automotive and safety standards. Its high-impact resistance helps defend against road debris, gravel, pitting, and even high-velocity impacts — all without interfering with visibility or the look of your vehicle. Trusted by global OEMs, this film is engineered for performance under pressure.</p>
        <hr />
        <h3>Smart Technology Meets Seamless Clarity</h3>
        <p>Engineered with state-of-the-art materials and optical-grade polymers, Cleargard enhances both safety and performance. It offers up to 99% UV protection, exceptional transparency, and self-healing capabilities that keep your windshield looking flawless for longer. Whether you're driving through harsh climates or simply want peace of mind, Cleargard delivers.</p>
        <hr />
        <h3>Available in Three High-Performance Options</h3>
        <div className="windshield-options">
          <h4>CLEARGARD-4 <span>4 MIL Film Thickness</span></h4>
          <ul>
            <li>Ideal for short-term or ongoing windshield protection</li>
            <li>Protects glass during transport, delivery, or assembly</li>
            <li>High-tack adhesive for superior grip; slightly longer removal time</li>
            <li>Balanced performance at a competitive price</li>
            <li>Crystal-clear optical clarity</li>
          </ul>
          <h4>CLEARGARD-6 <span>6 MIL Film Thickness</span></h4>
          <ul>
            <li>Heavy-duty protection for extended use in demanding environments</li>
            <li>Virtually invisible once installed</li>
            <li>Features a clean-release adhesive for easy removal without residue</li>
            <li>Helps prevent chips, cracks, and expensive windshield replacements</li>
            <li>Perfect for daily driving or long-haul commercial use</li>
          </ul>
          <h4>CLEARGARD-8 <span>8 MIL Film Thickness</span></h4>
          <ul>
            <li>Maximum-strength windshield protection for extreme road and weather conditions</li>
            <li>Engineered for high-impact resistance against large debris and harsh environments</li>
            <li>Ideal for off-road vehicles, industrial fleets, or regions with severe climates</li>
            <li>Maintains clear visibility with minimal distortion despite added thickness</li>
            <li>Long-lasting durability with enhanced shielding from chips, cracks, and pitting</li>
          </ul>
        </div>
        <hr />
        <h3>Why Choose Cleargard?</h3>
        <ul>
          <li>✅ High Transparency: Maintains optical clarity and driver visibility</li>
          <li>✅ Self-Healing Surface: Minor abrasions disappear over time</li>
          <li>✅ UV Protection: Blocks 99% of harmful UV rays</li>
          <li>✅ Cost-Saving: Reduces long-term maintenance and replacement expenses</li>
          <li>✅ OEM-Trusted: Built to meet automotive industry standards</li>
        </ul>
        <hr />
        <h2>Chipgard</h2>
        <h3>Invisible Strength. Crystal-Clear Defense.</h3>
        <p>Chipgard, developed by Derma Protec Films, is a next-generation TPU windshield protection film crafted to shield your glass from stone chips, road debris, and environmental damage—while maintaining exceptional visual clarity. At 7.5mil thickness, this premium film provides superior impact resistance and durability. Whether you're a casual cruiser or a daily driver, Chipgard offers long-term protection without compromising your driving experience.</p>
        
        <div className="windshield-image-container">
          <img 
            src="https://i.postimg.cc/qqjD3XYC/windshield-protec-derma-2.png" 
            alt="DermaProtec Chipgard Windshield Protection Technology" 
            className="windshield-content-image"
          />
        </div>
        <hr />
        <h3>Why Choose Chipgard?</h3>
        <ul>
          <li>✅ Cutting-Edge Coating Innovation</li>
          <li>✅ Clarity Without Compromise</li>
          <li>✅ Smooth Installation with Invisi-Adhesive™ Tech</li>
        </ul>
        <hr />
        <h3>Additional Highlights</h3>
        <ul>
          <li>Self-Healing Properties: Minor scuffs and surface scratches vanish with heat or time, keeping the film looking brand-new.</li>
          <li>UV & Glare Reduction: Shields your cabin from UV rays and glare, contributing to better driving comfort.</li>
          <li>Sensor & Camera Safe: Chipgard is fully compatible with ADAS features and won't interfere with onboard sensors or lane-assist cameras.</li>
          <li>Easy to Maintain: Hydrophobic surface repels water, dirt, and grime, making cleaning effortless.</li>
        </ul>
        <hr />
        <h3>Protect What You See Through</h3>
        <p>From rugged terrains to daily highway commutes, Chipgard keeps your windshield protected and clear—so you can drive with confidence, day or night.<br />Chipgard – Engineered Clarity. Everyday Toughness.</p>
        <h4>Limited Warranty</h4>
        <p>Chipgard comes with a limited 18 to 24-month warranty, depending on your region. The warranty covers product issues such as:</p>
        <ul>
          <li>Discoloration</li>
          <li>Peeling or delamination</li>
          <li>Blistering or cracking</li>
        </ul>
        <p>Please consult your local sales agent for region-specific warranty details.</p>
        <hr />
        <h3>Why Choose Derma Protec Windshield Protection Film?</h3>
        <ul>
          <li>✅ Advanced TPU construction for maximum flexibility and impact absorption</li>
          <li>✅ Preserves windshield quality and clarity</li>
          <li>✅ Significantly reduces glass maintenance and repair costs</li>
          <li>✅ Enhances driver and passenger safety</li>
          <li>✅ Invisible once installed—no compromise on appearance</li>
        </ul>
        <hr />
        <p>Protect your view. Enhance your drive.<br />Cleargard is the intelligent choice for those who value clarity, safety, and lasting performance in every journey.</p>
      </section>

      <div className="cta-section">
        <h2>Ready to Protect Your Windshield?</h2>
        <p>
          Experience the ultimate in windshield protection with our advanced film technology. 
          Contact us today to schedule your installation or learn more about our protection solutions.
        </p>
        <div className="cta-buttons">
          <a href="/find-dealer" className="cta-button primary">Find a Dealer Centre</a>
          <a href="/contact" className="cta-button secondary">Contact Us</a>
        </div>
      </div>
    </div>
  );
};

export default WindshieldProtectionPage; 